import { DEFAULT_CREDIT_VALUE_USD } from '@/lib/credits/estimate';

type CreditRateResponse = { creditValueUsd: number };

/**
 * 积分汇率当前为固定值（1 credit = $0.01）。
 * 为避免在新建/选中节点等高频场景触发网络请求，这里不再调用 `/api/credits/rate`。
 */
export function useCreditRate() {
  return {
    data: { creditValueUsd: DEFAULT_CREDIT_VALUE_USD } satisfies CreditRateResponse,
    error: undefined,
    isLoading: false,
  } as const;
}